import React, { useEffect, useState } from 'react';
import ApiClient from '../../Services/ApiClient';
import { useResources } from '../../store/resourcesProvider';

const GuestBotLazy = React.lazy(() => import('./GuestBot'));

const GuestBotLoader: React.FC = () => {
    const { siteId } = useResources();
    const [enabled, setEnabled] = useState<boolean | null>(null);

    useEffect(() => {
        let mounted = true;
        const load = async () => {
            try {
                // Use host-resolving endpoint so client does not need accurate siteId
                const data: any = await ApiClient.get(`/api/settings/site/current/settings`);
                if (!mounted) return;
                const ok = data && (
                    data.EnableGuestBot === true || data.EnableGuestBot === 'true' ||
                    data.enableGuestBot === true || data.enableGuestBot === 'true'
                );
                setEnabled(Boolean(ok));
            } catch (e) {
                console.debug('[GuestBotLoader] failed to load site settings', e);
                setEnabled(false);
            }
        };
        load();
        return () => { mounted = false; };
    }, [siteId]);

    if (!enabled) return null;

    return (
        <React.Suspense fallback={null}>
            <GuestBotLazy />
        </React.Suspense>
    );
};

export default GuestBotLoader;
